export default "__VITE_ASSET__CpIJS1bL__"